import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Icon } from '@shared/ui/components/Icon';

import Confirm from '../../../../base/Confirm';
import ListView from '../../../../base/ListView';
import { toImmutable } from '../../../../libs/immutable-transformer';
import { dateRender } from '../../../../libs/utils';
import { USERS_ACTIONS } from '../../../../redux/users/actions';
import { selectUsers, usersMeta } from '../../../../redux/users/selectors';
import AdminSubHeader from '../../../layouts/partials/AdminSubheader';

class _Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: this.props.users,
      baseFilters: toImmutable({
        'page[number]': 1,
        'page[size]': 10,
        'sort': '-updated_at',
        'filter[admin]': 1,
        'include': 'permission-preset',
      }),
    };

    this._handleDelete = this._handleDelete.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
  }

  static propTypes = {
    'loadUsers': PropTypes.func,
    'users': PropTypes.array,
    'users.map': PropTypes.func,
    'deleteUser': PropTypes.func,
    'usersMeta': PropTypes.object,
    'updateFilters': PropTypes.func,
  };

  UNSAFE_componentWillMount() {
    this.props.updateFilters(this.state.baseFilters);
    this.props.loadUsers();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      users: nextProps.users,
    });
  }

  _handleFilterUpdate(filters) {
    this.props.updateFilters(filters);
  }

  _handleDelete(id) {
    Confirm('Are you sure you want to delete this User?', {
      title: 'Delete User',
      confirmStyle: 'btn-danger',
      confirmText: 'Delete',
    }).then(
      (result) => {
        this.props.deleteUser(id);
      },
      (result) => {}
    );
  }

  render() {
    const { users, baseFilters } = this.state;
    const { usersMeta } = this.props;

    const listViewConf = {
      dataSet: users,
      dataMeta: usersMeta,
      columns: [
        {
          key: 'name',
          value: 'Name',
          sort: 'name',
          render: (user) => user.firstName + ' ' + user.lastName,
        },
        {
          key: 'permissionPreset.name',
          value: 'Group',
        },
        {
          key: 'twoFactorEnabled',
          value: '2FA',
          render: (user) => (user.twoFactorEnabled ? <Icon icon="check" /> : <Icon icon="cross" />),
        },
        {
          key: 'updatedAt',
          value: 'Last Updated',
          sort: 'updated_at',
          render: (user) => dateRender(user.updatedAt),
        },
      ],
      baseFilters: baseFilters,
      filters: [
        {
          label: 'Name',
          icon: 'la-search',
          type: 'text',
          key: 'name',
        },
        {
          label: 'Admin',
          type: 'checkbox',
          key: 'admin',
          value: 1,
        },
        {
          label: '2FA Status',
          type: 'select',
          key: 'two_factor_enabled',
          dataset: [
            { key: '1', value: '2FA Enabled' },
            { key: '0', value: '2FA Disabled' },
          ],
        },
      ],
      actions: {
        deleteLink: true,
        editLink: true,
        detailsLink: false,

        deleteFunction: this._handleDelete,
      },
      url: '/admin/users',
    };

    return [
      <AdminSubHeader title="Users" key="subheader" breadcrumbs={[]}>
        <Link
          to="/admin/users/create"
          className="btn btn-outline-success m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill m-btn--air"
        >
          <i className="la la-plus" />
        </Link>
      </AdminSubHeader>,
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-xl-12">
            <ListView
              config={listViewConf}
              handleDelete={this._handleDelete}
              handleFilterUpdate={this._handleFilterUpdate}
            />
          </div>
        </div>
      </div>,
    ];
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadUsers: (params) => dispatch(USERS_ACTIONS.loadAllRequest(params)),
  deleteUser: (id) => dispatch(USERS_ACTIONS.deleteRequest(id)),
  updateFilters: (filters) => dispatch(USERS_ACTIONS.updateFilters(filters)),
});

const mapStateToProps = function (state) {
  return {
    users: selectUsers(state),
    usersMeta: usersMeta(state),
  };
};

const Users = connect(mapStateToProps, mapDispatchToProps)(_Users);

export default Users;
